import { ObjectSchema, array, number, object } from "yup";
import { ResCallback } from "../../../../../models";
import { SubmitBlankMediaProfessionalUserApplication } from "../../../../../generated/data-contracts";
import {
  numberInteger,
  requiredBoolean,
  requiredClassifierId,
  requiredString,
} from "../../../../../data/yupConstants";

const validationSectionEquipApplications = (res: ResCallback) => {
  return object().shape({
    blankMediaTypeImporterSummaryId: number(),
    equipmentId: requiredClassifierId(res),
    personId: requiredClassifierId(res),
    balance: numberInteger(res, true, true),
    purchased: numberInteger(res, true, true),
    spent: numberInteger(res, true, true),
    utilizationOfEachUnit: requiredString(res, 1, 200),
  });
};
export const validationSchemaBlankMediaProfessionalUserApplication = (
  res: ResCallback,
  acceptedNoDeals: boolean,
): ObjectSchema<SubmitBlankMediaProfessionalUserApplication> | undefined => {
  const validationSchema: ObjectSchema<SubmitBlankMediaProfessionalUserApplication> =
    object({
      blankMediaTypeId: number(),
      dealNotOccuredPortal: requiredBoolean(res).test(
        "NoDealAcceptNeeded",
        res("validation_ApproveRequired"),
        (value) => {
          if (value == acceptedNoDeals) return true;
        },
      ),
      submitReport: requiredBoolean(res),
      dateFrom: requiredString(res),
      dateTo: requiredString(res),
      equipApplications: array().when(["dealNotOccuredPortal"], {
        is: (dealNotOccuredPortal: boolean) => dealNotOccuredPortal === false,
        then: () => array().of(validationSectionEquipApplications(res)),
      }),
    });

  return validationSchema;
};
